const NOTEBOOK_TEMPLATES = [
  {
    name: 'Daily Trading Plan',
    category: 'plan',
    content: `## Market Bias
- Overall market direction:
- Key economic events today:

## Key Levels
| Pair | Support | Resistance | Notes |
|------|---------|-----------|-------|
|      |         |           |       |

## Trade Ideas
1.
2.
3.

## Rules for Today
- Max trades:
- Max risk per trade:
- Stop trading if:
`,
  },
  {
    name: 'Weekly Review',
    category: 'review',
    content: `## Week of: [DATE]

## Results
- Trades taken:
- Win rate:
- Total P&L:

## What Went Well
-

## What to Improve
-

## Lessons Learned
-

## Goals for Next Week
-
`,
  },
  {
    name: 'Watchlist',
    category: 'watchlist',
    content: `## Watchlist — [DATE]

| Pair | Direction | Key Level | Setup | Notes |
|------|-----------|-----------|-------|-------|
|      |           |           |       |       |

## Notes
-
`,
  },
  {
    name: 'Pre-Market Checklist',
    category: 'plan',
    content: `## Pre-Market Checklist

- [ ] Check economic calendar
- [ ] Review overnight moves
- [ ] Mark key support/resistance levels
- [ ] Check higher timeframe trend
- [ ] Set max risk for the day
- [ ] Review yesterday's trades
- [ ] Clear mental state — no revenge trading

## Market Overview
-

## Today's Focus
-
`,
  },
  {
    name: 'Trade Review',
    category: 'review',
    content: `## Trade Review

### Setup
- Pair:
- Direction:
- Timeframe:
- Setup type:

### Entry
- Entry reason:
- Entry quality (1-5):

### Management
- Did I follow my plan?
- Did I move my stop?

### Exit
- Exit reason:
- Exit quality (1-5):

### Lessons
- What I did well:
- What I'd do differently:
`,
  },
  {
    name: 'Monthly Performance',
    category: 'review',
    content: `## Monthly Review — [MONTH]

## Stats
- Total trades:
- Win rate:
- Total P&L:
- Best trade:
- Worst trade:
- Max drawdown:

## Best Setups
1.
2.

## Biggest Mistakes
1.
2.

## Goals for Next Month
1.
2.
3.
`,
  },
];

export default NOTEBOOK_TEMPLATES;
